<section>
    <img src="assets/img/404-error.svg" alt="404 error image">
    <h1 class="text-center">{{ 'PageNotFoundErrorMessage' | localize }}</h1>
</section>
